export default {
  maxPrintHeight: 328,
};
